// Angular import
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

// Project import

import { NavBarComponent } from './nav-bar/nav-bar.component';
import { NavigationComponent } from './navigation/navigation.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { SettingsSidebarComponent } from './settings-sidebar/settings-sidebar.component';
import { RoleSelectorComponent } from '../../../Shared/components/role-selector/role-selector.component';
import { BreadcrumbComponent } from 'src/app/theme/shared/components/breadcrumb/breadcrumb.component';
import { ResponsiveControlsComponent } from '../../../Shared/components/responsive-controls/responsive-controls.component';
import { ResponsiveViewService } from '../../../Shared/Services/responsive-view.service';
import { RoleService, Role } from '../../../Shared/Services/role.service';

@Component({
  standalone: true,
  selector: 'app-admin',
  imports: [CommonModule, BreadcrumbComponent, NavigationComponent, NavBarComponent, RouterModule, ConfigurationComponent, SettingsSidebarComponent, RoleSelectorComponent, ResponsiveControlsComponent],
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss', './responsive-global.css']
})
export class AdminComponent {
  // public props
  navCollapsed: boolean = false;
  navCollapsedMob: boolean = false;
  showResponsiveControls: boolean = false;
  currentView: string = 'desktop';
  settingsSidebarOpen: boolean = false;
  roleSelectorOpen: boolean = false;
  currentRole: Role | null = null;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private responsiveViewService: ResponsiveViewService, private roleService: RoleService) {
    // Initialize current view from service
    this.currentView = this.responsiveViewService.getCurrentView();
    this.applyResponsiveClass(this.currentView);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      setTimeout(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        const data = route.snapshot.data;
        this.showResponsiveControls = !!data['showResponsiveControls'];
        console.log('Route:', route.snapshot.routeConfig?.path, 'Data:', data, 'Show controls:', this.showResponsiveControls);
        
        // Always apply current responsive view after route change
        this.applyResponsiveClass(this.currentView);
      }, 0);
    });

    this.responsiveViewService.currentView$.subscribe(view => {
      this.currentView = view;
      this.applyResponsiveClass(view);
    });

    // Load current role on init
    this.currentRole = this.roleService.getCurrentRole();
  }

  // public method
  navMobClick() {
    if (this.navCollapsedMob && !document.querySelector('app-navigation.pc-sidebar')?.classList.contains('mob-open')) {
      this.navCollapsedMob = !this.navCollapsedMob;
      setTimeout(() => {
        this.navCollapsedMob = !this.navCollapsedMob;
      }, 100);
    } else {
      this.navCollapsedMob = !this.navCollapsedMob;
    }
    if (document.querySelector('app-navigation.pc-sidebar')?.classList.contains('navbar-collapsed')) {
      document.querySelector('app-navigation.pc-sidebar')?.classList.remove('navbar-collapsed');
    }
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.closeMenu();
    }
  }

  closeMenu() {
    if (document.querySelector('app-navigation.pc-sidebar')?.classList.contains('mob-open')) {
      document.querySelector('app-navigation.pc-sidebar')?.classList.remove('mob-open');
    }
  }

  onViewChange(view: string) {
    console.log('Admin layout onViewChange:', view);
    this.currentView = view;
    this.responsiveViewService.setView(view);
    this.applyResponsiveClass(view);
  }

  applyResponsiveClass(view: string) {
    console.log('Applying responsive class:', `responsive-${view}`);
    const html = document.documentElement;
    
    // Force remove all responsive classes
    html.className = html.className.replace(/responsive-\w+/g, '');
    
    // Add new class
    html.classList.add(`responsive-${view}`);
    
    console.log('HTML classes after update:', html.className);
    console.log('HTML element:', html);
    
    // Also try adding to body as backup
    document.body.className = document.body.className.replace(/responsive-\w+/g, '');
    document.body.classList.add(`responsive-${view}`);
  }

  isPreviewMode(): boolean {
    return document.body.hasAttribute('data-show-responsive-controls');
  }

  toggleSettingsSidebar() {
    this.settingsSidebarOpen = !this.settingsSidebarOpen;
  }

  closeSettingsSidebar() {
    this.settingsSidebarOpen = false;
  }

  toggleRoleSelector() {
    this.roleSelectorOpen = !this.roleSelectorOpen;
  }

  closeRoleSelector() {
    this.roleSelectorOpen = false;
  }

  onRoleSelected(role: Role) {
    this.currentRole = role;
    console.log('Role selected:', role);
    // Force navigation update
    setTimeout(() => {
      this.roleService.setCurrentRole(role);
    }, 0);
  }
}
